<template>
  <div
    ref="dottedMenu"
    :class="[classNamePrefix, placementClass, activeClass]"
    @mouseleave="onMouseLeaveWhole"
  >
    <i
      class="fa fa-ellipsis-v"
      @click="toggleMenu"
    />
    <div class="menu-slot">
      <div
        class="menu-slot__box"
        :class="[color]"
      >
        <slot>
          <button class="menu-btn">
            {{ $t('addOption') }}
          </button>
          <button class="menu-btn">
            {{ $t('deleteOption') }}
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { onClickOutside } from '@vueuse/core'

export default {
  name: 'DottedMenu',
  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    color: {
      type: String,
      default: 'none',
      validator: (val) => {
        const vals = ['none', 'darkblue']
        return vals.includes(val)
      },
    },
    enableClickOutClose: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      classNamePrefix: 'dotted-menu',
      isActive: false,
    }
  },
  computed: {
    placementClass () {
      return `${this.classNamePrefix}-${this.placement}`
    },
    activeClass () {
      return this.isActive ? 'is-active' : ''
    },
  },
  mounted () {
    onClickOutside(this.$refs.dottedMenu, () => {
      if (!this.enableClickOutClose) return
      this.isActive = false
    })
  },
  methods: {
    onMouseLeaveWhole () {
      if (this.enableClickOutClose) return
      this.isActive = false
    },
    toggleMenu: _.debounce(function () {
      this.isActive = !this.isActive
    }, 100),
    closeMenu () {
      this.isActive = false
    },
  },
}
</script>

<style scoped lang="scss">
.dotted-menu {
  position: relative;
  .fa-ellipsis-v {
    margin: 5px 10px;
    color: #33698f;
    font-size: 25px;
    font-weight: lighter;
    cursor: pointer;
  }
  .menu-slot {
    position: absolute;
    z-index: 999;
    border-style: solid;
    border-width: 0.5px;
    border-image-source: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4) 5%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0));
    min-width: 60px;
    margin: 0;
    display: none;
    @media screen and (max-width: 1440px) {
      & {
        top: 100%;
        right: 0;
        left: auto;
      }
    }
    &__box {
      display: flex;
      flex-direction: column;
      background-color: white;
      button, a {
        color: #0c3a58;
        text-align: left;
        font-weight: normal;
        padding: 0.65em 1em;
        border: solid 1px #B5B5B5;
        font-family: Verdana;
        font-size: 14px;
        cursor: pointer;
        &:not(:last-child) {
          border-bottom: none;
        }
        &:hover {
          background-color: #969faf;
          color: white;
        }
      }
      &.darkblue {
        background-color: #1a557d;
        button, a {
          color: white;
          border: none;
          font-weight: bold;
          &:hover {
            background-color: initial;
          }
        }
      }
    }
  }
  &.is-active {
    .menu-slot {
      display: flex;
    }
  }
  &-top {
    .menu-slot {
      bottom: 100%;
    }
  }
  &-right {
    .menu-slot {
      top: 12%;
      left: 20px;
    }
  }
  &-left {
    .menu-slot {
      top: 12%;
      left: -122px;
    }
  }
}
</style>
